import springRadiance from "../img/buchete-de-primavara/1spring-radiance.webp";
import awakening from "../img/buchete-de-primavara/2awakening.webp";
import joyfulEssence from "../img/buchete-de-primavara/3joyful-essence.webp";
// import bloomBurst from "../img/buchete-de-primavara/4bloom-burst.webp";
import softlySpoken from "../img/buchete-de-primavara/5softly-spoken.webp";
import mistyBlossom from "../img/buchete-de-primavara/6misty-blossom.webp";
import blushRomance from "../img/buchete-de-primavara/7blush-romance.webp";
import tulipReverie from "../img/buchete-de-primavara/8tulip-reverie.webp";
import delicateSpring from "../img/buchete-de-primavara/9delicate-spring.webp";
import cloudyDaydream from "../img/buchete-de-primavara/10cloudy-daydream.webp";
// import layersOfSun from "../img/buchete-de-primavara/11layers-of-sun.webp";
import flameOfSpring from "../img/buchete-de-primavara/12flame-of-spring.webp";
// import springElegance from "../img/buchete-de-primavara/13spring-elegance.webp";
import springPoetry from "../img/buchete-de-primavara/14spring-poetry.webp";
import hush from "../img/buchete-de-primavara/15hush.webp";
import silvaPinkAndTulips from "../img/trandafiri/4silva-pink-and-tulips.webp";
import winterMorning from "../img/buchete-de-primavara/17winter-morning.webp";
import etherealBlush from "../img/buchete-de-primavara/18ethereal-blush.webp";
import colourfulGlow from "../img/buchete-de-primavara/19colourful-glow.webp";
import frostedBloom from "../img/buchete-de-primavara/20frosted-bloom.webp";
import sunshineBlooms from "../img/buchete-de-primavara/21sunshine-blooms.webp";
import laurel from "../img/new/003laurel.webp";
import primrose from "../img/new/002primrose.webp";
import dahlia from "../img/new/006dahlia.webp";
import cloudscape from "../img/buchete/22cloudscape.webp";
import zephyr from "../img/buchete/68zephyr.webp";
import springsonet from "../img/new/012springsonet.webp";
import suspiro from "../img/may2026/01_suspiro.webp";
import dreamCloud from "../img/may2026/02_dream_cloud.webp";
import springWhisper from "../img/may2026/03_spring_whisper.webp";
import blueAvalanche from "../img/may2026/04_blue_avalanche.webp";
import sofiaInBloom from "../img/may2026/05_sofia_in_bloom.webp";
import coralPeony from "../img/may2026/06_coral_peony.webp";
import bloom from "../img/cele-mai-vindute/Bloom.webp";
import coralInSpring from "../img/may2026/07_coral_in_spring.webp";
import coralSilvaMix from "../img/may2026/08_coral_silva_mix.webp";
import springInGreen from "../img/may2026/09_spring_in_green.webp";
import anturiumLove from "../img/may2026/10_anturium_love.webp";
import lunaBloom from "../img/feb2026/luna_bloom.webp";
import tenderMood from "../img/may2026/11_tender_mood.webp";
import beSweet from "../img/may2026/12_be_sweet.webp";
import calmAndLovely from "../img/may2026/13_calm_and_lovely.webp";
import justForYou from "../img/may2026/14_just_for_you.webp";
import pureFeeling from "../img/may2026/15_pure_feeling.webp";
import alpinePetals from "../img/feb2026/alpine_petals.webp";
import peonyBloom from "../img/may2026/16_peony_bloom.webp";
import floralStory from "../img/may2026/17_floral_story.webp";
import velvetPeony from "../img/may2026/18_velvet_peony.webp";
import tenderCharm from "../img/may2026/19_tender_charm.webp";
import dreamer from "../img/may2026/20_dreamer.webp";
import sweetMorning from "../img/may2026/21_sweet_morning.webp";
import gentleDream from "../img/may2026/22_gentle_dream.webp";
import nudeBouquet from "../img/may2026/23_nude_bouquet.webp";
import softStory from "../img/may2026/24_soft_story.webp";
// import petiteCoralCharm from "../img/buchete-de-vara/21petite-coral-charm.webp";

//1051-1150
const bucheteIarnaPrimavara = [
  {
    id: 1103,
    name: "Soft Story",
    price: "800 lei",
    description:
      "Buchet format din hortensie, trandafiri crenguta, eustoma și eucalipt.",
    images: [softStory],
  },
  {
    id: 1102,
    name: "Nude Bouquet",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri cu un cap, trandafiri Silva Pink, eustoma, crizantema și eucalipt.",
    images: [nudeBouquet],
  },
  {
    id: 1100,
    name: "Sweet Morning",
    price: "550 lei",
    description: "Buchet format din bujori, eustome, matiola si crizantema.",
    images: [sweetMorning],
  },
  {
    id: 1096,
    name: "Floral Story",
    price: "800 lei",
    description:
      "Buchet format din hortensii, bujori, eustoma, crizantema și eucalipt.",
    images: [floralStory],
  },
  {
    id: 1080,
    name: "Suspiro",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, Matiola, trandafiri crenguța, eustome și eucalipt. ",
    images: [suspiro],
  },

  {
    id: 1081,
    name: "Dream Cloud",
    price: "1700 lei",
    description:
      "Buchet format din trandafiri de tip Bujor Silva Pink, gipsofila și eucalipt. ",
    images: [dreamCloud],
  },
  {
    id: 1082,
    name: "Spring Whisper",
    price: "2300 lei",
    description:
      "Buchet format din hortensie, vibrunum, trandafiri de tip Bujor, eustoma, crizantema și eucalipt. ",
    images: [springWhisper],
  },
  {
    id: 1083,
    name: "Blue Avalanche",
    price: "900 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome, dianthus și eucalipt. ",
    images: [blueAvalanche],
  },
  {
    id: 1084,
    name: "Sofia In Bloom",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri crenguța Sofia, eustome și eucalipt. ",
    images: [sofiaInBloom],
  },
  {
    id: 1088,
    name: "Spring In Green",
    price: "1600 lei",
    description:
      "Buchet format din hortensie, anturium, trandafiri de tip bujor, matiola, eustome, vibrunum și eucalipt. ",
    images: [springInGreen],
  },

  {
    id: 1089,
    name: "Anturium Love",
    price: "2500 lei",
    description:
      "Buchet format din hortensii, anturium, trandafiri de tip bujor Silva Pink, vibrunum, matiola, eustome și eucalipt. ",
    images: [anturiumLove],
  },
  {
    id: 1090,
    name: "Tender Mood",
    price: "1400 lei",
    description:
      "Buchet format din crengi de trandafiri de tip bujor Silva Pink. ",
    images: [tenderMood],
  },
  {
    id: 1091,
    name: "Be Sweet",
    price: "3000 lei",
    description: "Buchet format din 35 trandafiri roz de lungime 80cm. ",
    images: [beSweet],
  },
  {
    id: 1092,
    name: "Calm & Lovely",
    price: "1900 lei",
    description:
      "Buchet format din hortensii, trandafiri de tip bujor, crizantema, eustome și eucalipt. ",
    images: [calmAndLovely],
  },
  {
    id: 1093,
    name: "Just For You",
    price: "2600 lei",
    description: "Buchet format din hortensii, trandafiri și eucalipt.",
    images: [justForYou],
  },
  {
    id: 1094,
    name: "Pure Feeling",
    price: "1750 lei",
    description:
      "Buchet format din hortensii, trandafiri Sofia, vibrunum, eustome și eucalipt.",
    images: [pureFeeling],
  },
  {
    id: 1051,
    name: "Laurel",
    price: "1550 lei",
    description: "Buchet gingas format din 39 de lalele. ",
    images: [laurel],
  },
  {
    id: 1052,
    name: "Primrose",
    price: "1150 lei",
    description: "Buchet format din mix de lalele si gispofila alba. ",
    images: [primrose],
  },
  {
    id: 1053,
    name: "Dahlia",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri, lalele, asothamus si eucalipt. ",
    images: [dahlia],
  },
  {
    id: 1054,
    name: "Spring Radiance",
    price: "950 lei",
    description: "Buchet elegant compus din 21 de lalele. ",
    images: [springRadiance],
  },
  {
    id: 1055,
    name: "Awakening",
    price: "450 lei",
    description:
      "Buchet format din lalele de tip bujor cu crengi decorative de primavara. ",
    images: [awakening],
  },
  {
    id: 1056,
    name: "Joyful Essence",
    price: "900 lei",
    description: "Buchet format dintr-un mix de lalele, fresie si eucalipt.",
    images: [joyfulEssence],
  },

  // {
  //   id: 1057,
  //   name: "Bloom Burst",
  //   price: "1000 lei",
  //   description:
  //     "Buchet superb din trandafiri, crizanteme, anturium, ilex si crengi decorative de brad.",
  //   images: [bloomBurst],
  //   checkAvailability: true,
  // },
  {
    id: 1058,
    name: "Softly Spoken",
    price: "950 lei",
    description: "Buchet elegant format din 21 de lalele.",
    images: [softlySpoken],
  },
  {
    id: 1059,
    name: "Misty Blossom",
    price: "1050 lei",
    description:
      "Buchet elegant din trandafiri rosii, lalele de tip bujor si eucalipt.",
    images: [mistyBlossom],
  },
  {
    id: 1060,
    name: "Blush Romance",
    price: "450 lei",
    description: "Buchet rafinat format din 9 lalele si verdeata decorativa.",
    images: [blushRomance],
  },
  {
    id: 1061,
    name: "Tulip Reverie",
    price: "1800 lei",
    description: "Buchet elegant format din 45 de lalele rosii și eucalipt.",
    images: [tulipReverie],
  },
  {
    id: 1062,
    name: "Delicate Spring",
    price: "1400 lei",
    description: "Buchet elegant format din 35 de lalele roz.",
    images: [delicateSpring],
  },
  {
    id: 1063,
    name: "Cloudy Daydream",
    price: "1300 lei",
    description:
      "Buchet format din hortensie, trandafiri, crizanteme, anturium si ilex.",
    images: [cloudyDaydream],
    checkAvailability: true,
  },
  // {
  //   id: 1064,
  //   name: "Layers of Sun",
  //   price: "500 lei",
  //   description:
  //     "Buchet format din astromerie, trandafiri, lalele si verdeata decorativa.",
  //   images: [layersOfSun],
  // },
  {
    id: 1065,
    name: "Flame of Spring",
    price: "1300 lei",
    description:
      "Buchet format din lalele rosii, fresie si trandafiri de tip crenguta.",
    images: [flameOfSpring],
  },
  // {
  //   id: 1066,
  //   name: "Spring Elegance",
  //   price: "750 lei",
  //   description:
  //     "Buchet elegant din lalele de tip bujor, trandafiri si eucalipt.",
  //   images: [springElegance],
  // },
  {
    id: 1067,
    name: "Spring Poetry",
    price: "2000 lei",
    description: "Buchet rafinat format din lalele de tip bujor.",
    images: [springPoetry],
    checkAvailability: true,
  },
  {
    id: 1068,
    name: "Hush",
    price: "1000 lei",
    description: "Buchet elegant format din lalele de tip bujor.",
    images: [hush],
  },
  {
    id: 1069,
    name: "Bloom",
    price: "2000 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor Silva Pink, lalele roz si eucalipt.",
    images: [silvaPinkAndTulips],
  },
  {
    id: 1070,
    name: "Zephyr",
    price: "1000 lei",
    description:
      "Buchet elegant format din trandafiri, astromerii, dianthus, ozothamus si wax flower.",
    images: [zephyr],
  },
  {
    id: 1071,
    name: "Cloudscape",
    price: "1400 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme, eustome, lalele, astromerii si eucalipt.",
    images: [cloudscape],
  },
  {
    id: 1072,
    name: "Winter Morning",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, fresie, trandafiri, lalele, gipsofila si eucalipt.",
    images: [winterMorning],
  },
  {
    id: 1073,
    name: "Ethereal Blush",
    price: "1500 lei",
    description: "Buchet format dintr-un mix de lalele.",
    images: [etherealBlush],
  },
  {
    id: 1504,
    name: "Luna Bloom",
    price: "2500 lei",
    description:
      "Buchet format din trandafir de tip bujor, lalele si eucalipt. ",
    images: [lunaBloom],
  },
  {
    id: 1074,
    name: "Colourful Glow",
    price: "500 lei",
    description: "Buchet format din fresie, lalele si astromerie.",
    images: [colourfulGlow],
  },
  {
    id: 1075,
    name: "Frosted Bloom",
    price: "700 lei",
    description:
      "Buchet format din crizanteme, trandafiri de tip bujor, gipsofila si crengi decorative de brad.",
    images: [frostedBloom],
  },
  {
    id: 1501,
    name: "Alpine Petals",
    price: "830 lei",
    description:
      "Buchet format din lalele, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [alpinePetals],
  },
  {
    id: 1076,
    name: "Sunshine Blooms",
    price: "1300 lei",
    description: "Buchet format dintr-un mix de lalele si wax flower.",
    images: [sunshineBlooms],
  },
  {
    id: 1077,
    name: "Spring Sonet",
    price: "650 lei",
    description:
      "Buchet format din trandafiri de tip crenguta, trandafiri de tip bujor, lalele si eucalipt.",
    images: [springsonet],
  },
  // {
  //   id: 1078,
  //   name: "Petite Coral Charm",
  //   price: "800 lei",
  //   description:
  //     "Buchet format din bujori Coral Charm, trandafiri, astromerii, antirinium si eucalipt.",
  //   images: [petiteCoralCharm],
  // },
];

export default bucheteIarnaPrimavara;
